<template>
  <v-container>
    <v-card>
      <v-container>
        <v-card-title>
          <!-- 取引先
          <v-spacer></v-spacer>-->
          <v-text-field v-model="search" label="会社名検索" single-line hide-details></v-text-field>
          <!-- append-icon="search"-->
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="storeMappings"
          :search="search"
          :custom-sort="customSort"
          :loading="loading"
          hide-actions
        >
          <template v-slot:items="props">
            <tr @click="forwardMakerEdit(props.item)">
              <td>{{ props.item.partnerCode  }}</td>
              <td>{{ props.item.brandName  }}</td>
              <td class="text-xs-left">{{ props.item.partnerStoreCode}}</td>
              <td class="text-xs-left">{{ props.item.officialStoreCode}}</td>
              <td class="text-xs-left">{{ props.item.partnerStoreName}}</td>
              <td class="text-xs-left">{{ props.item.note}}</td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
            >検索キーワード["{{ search }}]に該当する製造会社名は存在しません</v-alert>
          </template>
        </v-data-table>
        <br />
      </v-container>
    </v-card>

    <br />
    <v-layout row wrap>
      <v-flex xs12 sm5>
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>Home
        </v-btn>
      </v-flex>
      <v-flex xs12 sm2></v-flex>
      <v-flex xs12 sm5>
        <v-btn block color="success" dark :to="{ name: 'admin/partner-store-mapping-regist' }">
          <v-icon dark left>create</v-icon>新規登録
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  created() {
    ServerApiCallService.storeMapping()
      .then(response => {        
        console.log("response.data: ", response.data);
        
        this.storeMappings = response.data.storeMappings
        this.loading = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
        this.loading = false
      })
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        const aValue = a.partnerCode
        const bValue = b.partnerCode

        if (!isDesc) {
          return aValue > bValue ? 1 : aValue < bValue ? -1 : 0
        } else {
          return aValue < bValue ? 1 : aValue > bValue ? -1 : 0
        }
      })

      return items
    },
    forwardMakerEdit(makerInfo) {
      // newMakerRegist에 값을 넘김
      this.$router.push({
        name: 'admin_makers_update',
        params: { makerId: makerInfo.makerId }
      })
    }
  },
  data() {
    return {
      loader: null,
      loading: true,
      search: '',
      headers: [
        { text: 'Partner Code', value: 'partnerCode' },
        { text: 'Brand Name', value: 'brandName' },
        { text: '店舗コード(Partner)', value: 'partnerStoreCode', sortable: false },
        { text: '店舗コード(Hirosophy)', value: 'officialStoreCode', sortable: false },
        { text: '店舗名', value: 'partnerStoreName', sortable: false },
        { text: 'note', value: 'note', sortable: false }
      ],
      storeMappings: []
    }
  }
}
</script>
